import icon from "../../assets/power.svg";
import type { Property } from "../../types";

export const accessPowerMethod: Property = {
  id: "accessPowerMethod",
  title: "accessPowerMethod.title",
  icon,
};
